import React from 'react';

import { DetectionIcon } from '@vlabs/icons';
import { Sample } from '@vlabs/shared/components/sample/Sample';
import { SimilarityTag } from '@vlabs/shared/components/similarity-tag/SimilarityTag';
import type { TTagKind } from '@vlabs/uikit';

import { MatchItem } from './MatchItem.jsx';
import st from './MatchList.module.sass';

interface MatchListProps {
  externalIdMatches?: unknown;
  listIdMatches?: unknown;
  similarityTagKind?: TTagKind;
}

function MatchList({
  externalIdMatches = undefined,
  listIdMatches = undefined,
  similarityTagKind = undefined,
}: MatchListProps): React.JSX.Element {
  const matches = externalIdMatches ?? listIdMatches;

  return (
    <div className={st.Root}>
      <div className={st.Matches}>
        {matches?.map((match) => (
          <div
            className={st.Match}
            key={JSON.stringify(match)}
          >
            {!!match?.matchListLabel && <span className={st.MatchListLabel}>{match.matchListLabel}</span>}
            <div
              className={st.Margin}
              key={match?.face_id}
            >
              <SimilarityTag
                className={st.SimilarityTag}
                icon={<DetectionIcon />}
                kind={similarityTagKind}
                size="large"
                value={match?.similarity}
              />
              <div className={st.Samples}>
                <Sample
                  className={st.Sample}
                  image={match?.uiDetectionURL}
                  type="face"
                />
                <MatchItem
                  avatar={match?.uiAvatarURL}
                  faceId={match?.face_id}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MatchList;
